module.exports = __webpack_public_path__ + "img/manafwa1.9a87ef32.jpg";